import request from '@/fetch/index'

// 获取全省市区列表
export function getFullArea({ cityCode = '' }) {
  return request({
    url: '/api/loan/area/app/v1/full-list',
    method: 'GET',
    params: {
      // cityCode
    }
  })
}
// 获取jxt地区id映射
export function getMappingAreaId(code, type = 1) {
  return request({
    url: `/api/loan/app/${code}/${type}`,
    method: 'GET'
  })
}
